import { importProvidersFrom } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { LOGGER_CONFIG } from 'app/shared/configuration/loggerConfig';
import { MaterialModule } from 'app/shared/material.module';
import { CommonBaseModule } from 'app/tinea-components/okta/common-base.module';
import { OktaModule } from 'app/tinea-components/okta/okta/okta.module';
import { PagingModule } from 'app/tinea-components/paging/paging.module';
import { LoggerModule } from 'ngx-logger';
import { QuillModule } from 'ngx-quill';
import { SharedModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { ProgressBarModule } from 'primeng/progressbar';
import { RippleModule } from 'primeng/ripple';
import { SplitterModule } from 'primeng/splitter';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { CoreModule } from '../core.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from '../translate/translate.core';
import { HttpClient } from '@angular/common/http';
import { MatDatepickerModule } from '@angular/material/datepicker';

export const provideAppLegacyModules = () => [
  importProvidersFrom(
    LoggerModule.forRoot(LOGGER_CONFIG),
    FormsModule,
    ReactiveFormsModule,
    GoogleMapsModule,
    SharedModule,
    CoreModule,
    OktaModule,
    PagingModule,
    QuillModule.forRoot(),
    TableModule,
    TooltipModule,
    ToastModule,
    ButtonModule,
    RippleModule,
    ProgressBarModule,
    MessagesModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatSidenavModule,
    CommonBaseModule,
    MaterialModule,
    SplitterModule,
    TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
    }),
  ),
];
